import React from "react";
import { motion } from "framer-motion";

/**
 * Masked line-by-line reveal for editorial hero typography.
 * Each child (line) sits inside overflow-hidden and rises from 100% into 0%.
 */
export const MaskedReveal = ({ children, delay = 0, className = "" }) => {
  const items = React.Children.toArray(children);
  return (
    <span className={className}>
      {items.map((child, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className="block will-change-transform"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1.1,
              delay: delay + i * 0.12,
              ease: [0.16, 1, 0.3, 1],
            }}
          >
            {child}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const FadeIn = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);
